export default {
  'schedules.list.header.actions': 'Actions',
  'schedules.list.column.actions.button': 'Rate',

  'schedules.domain.requests.date': 'Schedule Date',
  'schedules.domain.requests.time': 'Time',
  'schedules.domain.requests.customer': 'Customer',
  'schedules.domain.requests.customer.name': 'Customer name',
  'schedules.domain.requests.customer.email': 'E-mail',
  'schedules.domain.requests.customer.phone': 'Phone',
  'schedules.domain.requests.vehicle': 'Vehicle',
  'schedules.domain.requests.vehicle.brand': 'Brand',
  'schedules.domain.requests.vehicle.model': 'Model',
  'schedules.domain.requests.vehicle.year': 'Year',
  'schedules.domain.requests.vehicle.color': 'Color',
  'schedules.domain.requests.vehicle.renavam': 'Renavam',
  'schedules.domain.requests.service': 'Services',
  'schedules.domain.requests.workshop': 'Workshop',
  'schedules.domain.requests.observation': 'Observation',
  'schedules.domain.requests.employee': 'Employee',
  'schedules.domain.requests.status': 'Status',
  'schedules.domain.requests.entry': 'Entry',
  'schedules.domain.requests.exit': 'Exit',
  'schedules.domain.requests.status.accepted': 'Accepted',
  'schedules.domain.requests.status.cancelled': 'Cancelled',
  'schedules.domain.requests.status.refused': 'Refused',
  'schedules.domain.requests.status.requested': 'Requested',
  'schedules.domain.requests.dayType.none': 'None',
  'schedules.domain.requests.dayType.sunday': 'Sunday',
  'schedules.domain.requests.dayType.monday': 'Monday',
  'schedules.domain.requests.dayType.tuesday': 'Tuesday',
  'schedules.domain.requests.dayType.wednesday': 'Wednesday',
  'schedules.domain.requests.dayType.thursday': 'Thursday',
  'schedules.domain.requests.dayType.friday': 'Friday',
  'schedules.domain.requests.dayType.saturday': 'Saturday',
  'schedules.domain.requests.serviceType.workshop': 'Workshop',
  'schedules.domain.requests.serviceType.bodywork': 'Bodywork',

  'schedules.requests.appointmentsDeclined': 'Appointments Declined',
  'schedules.requests.filters.workshop': 'Filter by workshop',
  'schedules.requests.filters.date': 'Filter by date',
  'schedules.requests.filters.time': 'Filter by time',

  'schedules.requests.modal.appointmentsDeclined.title': 'Requests Declined',

  'schedules.requests.modal.title': 'Schedule',
  'schedules.requests.modal.title.services': 'Services',
  'schedules.requests.modal.title.customers': 'Customers',
  'schedules.requests.modal.title.vehicles': 'Vehicles',
  'schedules.requests.modal.buttons.accept': 'Accept',
  'schedules.requests.modal.buttons.refuse': 'Refuse',

  'schedules.requests.edit.notication.success': 'Schedule edited successfully!',
  'schedules.requests.edit.notication.successDescription':
    'The appointment date has been edited successfully.',

  'schedules.requests.refuse.modal.title':
    'Would you like to decline this schedule?',
  'schedules.requests.refuse.modal.form.obs': 'Observation',
  'schedules.requests.refuse.modal.button.refuseText': 'Refuse',
  'schedules.requests.refuse.notication.success':
    'Schedule declined successfully!',
  'schedules.requests.refuse.notication.successDescription':
    'The schedule was successfully declined.',
  'schedules.requests.accept.notication.success':
    'Schedule accepted successfully!',
  'schedules.requests.accept.notication.successDescription':
    'The schedule was successfully accepted.',

  'schedules.requests.history.modal.title': 'Refused schedules',
  'schedules.requests.history.modal.buttons.confirm': 'Confirm',
  'schedules.requests.history.modal.buttons.close': 'Close',
  'schedules.requests.history.button.reOpen': 'Reopen schedule',
  'schedules.requests.history.reOpen.notication.success': 'Reopened schedule',
  'schedules.requests.history.reOpen.notication.successDescription':
    'The schedule was successfully reopened.',

  'schedules.scheduling.newSchedule': 'New Schedule',
  'schedules.scheduling.modal.buttons.cancelText': 'Close',
  'schedules.scheduling.modal.buttons.okText': 'Save',
  'schedules.scheduling.modal.buttons.newOrder': 'Transform into work order',
  'schedules.scheduling.update.notication.success': 'Schedule updated!',
  'schedules.scheduling.update.notication.successDescription':
    'The schedule has been successfully updated.',
  'schedules.scheduling.create.notication.success': 'Schedule created!',
  'schedules.scheduling.create.notication.successDescription':
    'The schedule has been successfully created.',

  'schedules.operation.label.selectCompany': 'Select a company',
  'schedules.operation.title.manPower': 'Man power',
  'schedules.operation.title.workingDays': 'Working Days',
  'schedules.operation.title.unavailableDays': 'Unavailable day',
  'schedules.operation.manPower.form.qtdVehiclesByHours':
    'Qtdy. of vehicles by hour',
  'schedules.operation.manPower.form.qtdVehiclesByPeriod':
    'Qtdy. of vehicles by period',
  'schedules.operation.manPower.notication.success': 'Man power updated!',
  'schedules.operation.manPower.notication.successDescription':
    "The company's man power has been successfully updated.",
  'schedules.operation.workingDays.notication.success': 'Updated working days!',
  'schedules.operation.workingDays.notication.successDescription':
    "The company's working days have been updated successfully.",
  'schedules.operation.unavailableDays.list.fields.allDay': 'All day',
  'schedules.operation.unavailableDays.list.fields.observation': 'Observation',
  'schedules.operation.unavailableDays.list.buttons.addDate': 'Add Date',
  'schedules.operation.unavailableDays.list.buttons.removeDate': 'Remove Date',
  'schedules.operation.unavailableDays.notication.success':
    'Special days successfully updated!',
  'schedules.operation.unavailableDays.notication.successDescription':
    'Special days were successfully associated.',

  'schedules.services.table.description': 'Description',
  'schedules.services.table.serviceType': 'Type',
  'schedules.services.linkServices.notication.success':
    'Successfully associated services!',
  'schedules.services.linkServices.notication.successDescription':
    'The selected services have been successfully associated.',

  'schedules.employee.table.workingDay': 'Working Day',
  'schedules.employee.newJourney': 'New Journey',
  'schedules.employee.newJourney.modal.title': 'New Employee',
  'schedules.employee.newJourney.modal.okText': 'Add',
  'schedules.employee.newJourney.modal.cancelText': 'Close',
  'schedules.employee.newJourney.form.searchEmployee': 'Search Employe',
  'schedules.employee.newJourney.form.removeJourney': 'Remove Journey',
  'schedules.employee.schedule.modal.title': 'Schedule',
  'schedules.employee.schedule.modal.okText': 'Save',
  'schedules.employee.schedule.table.changeEmployee': 'Change Employee',
  'schedules.employee.schedule.table.followSchedule': 'Follow Schedule',
};
